import { createFileRoute } from '@tanstack/react-router'
import { RequireAuth } from '@dss/auth'
import { OrderEditRoute } from '../features/orders/OrderEditRoute'

/** Старая ссылка: объяснение без чтения или изменения через закрытый API. */
export const Route = createFileRoute('/orders/$id/edit')({
  component: OrderEditRouteWrapper,
})

function OrderEditRouteWrapper() {
  const { id } = Route.useParams()
  return (
    <RequireAuth>
      <OrderEditRoute orderId={Number(id)} />
    </RequireAuth>
  )
}
